export class TokenManager {
  private jwt: string | null = null
  private baseUrl: string
  private refreshingPromise: Promise<string | null> | null = null

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl
  }

  setToken(token: string | null) {
    this.jwt = token
  }

  getToken(): string | null {
    return this.jwt
  }

  async refreshToken(): Promise<string | null> {
    if (!this.refreshingPromise) {
      this.refreshingPromise = fetch(`${this.baseUrl}/refresh`, {
        method: "POST",
        credentials: "include",
      })
        .then(async (res) => {
          if (!res.ok) throw new Error("Failed to refresh token")
          const data = await res.json()
          this.jwt = data.accessToken
          return data.accessToken
        })
        .catch((e) => {
          this.jwt = null
          return Promise.reject(e)
        })
        .finally(() => {
          this.refreshingPromise = null
        })
    }
    return this.refreshingPromise
  }
}
